/**
	MAIN.JS

    In this file, all used JavaScript modules come together ans one, as they are initialized right here.
 */
'use strict';

import Accordion from './modules/accordion';
import CookieByte from './modules/cookie-byte';
import Form from './form/form';
import Headermenu from './navigation/navigation';
import ImageGallery from './modules/image-gallery';
import MediaViewer from './modules/media-viewer';
import VueApplication from './modules/components';
import InitFilterSection from './customer/filter';

const siteInitialization = () => {
	VueApplication.init();
	CookieByte.init();
	Headermenu.init();
	Accordion.init();
	ImageGallery.init();
	MediaViewer.init();
	Form.init();
	InitFilterSection();
	// testSites();
};

const testSites = () => {
	const sitemap = {
		"urlset": {
		  "url": [
			{
			  "loc": "http://frc.localhost/ueber-uns",
			  "lastmod": "2023-08-08",
			  "changefreq": "monthly",
			  "priority": 0.7
			},
			{
			  "loc": "http://frc.localhost/werner-lehner",
			  "lastmod": "2023-02-07",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/leistungen",
			  "lastmod": "2023-02-07",
			  "changefreq": "monthly",
			  "priority": 0.7
			},
			{
			  "loc": "http://frc.localhost/kontakt",
			  "lastmod": "2023-07-03",
			  "changefreq": "never",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/jobs",
			  "lastmod": "2023-04-03",
			  "changefreq": "yearly",
			  "priority": 0.3
			},
			{
			  "loc": "http://frc.localhost/impressum",
			  "lastmod": "2022-07-08",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost",
			  "lastmod": "2023-07-03",
			  "changefreq": "monthly",
			  "priority": 1
			},
			{
			  "loc": "http://frc.localhost/heinz-hofstaetter",
			  "lastmod": "2023-04-03",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/esg-nachhaltigkeit",
			  "lastmod": "2023-06-23",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/datenschutz",
			  "lastmod": "2023-05-22",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/datenschutzerklaerung",
			  "lastmod": "2023-02-20",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog",
			  "lastmod": "2023-04-05",
			  "changefreq": "weekly",
			  "priority": 0.7
			},
			{
			  "loc": "http://frc.localhost/blog/preisuebergabe-1",
			  "lastmod": "2023-08-03",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/ankick-in-hap",
			  "lastmod": "2023-08-01",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/festlegung-fixzinssatz",
			  "lastmod": "2023-07-12",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/spatenstich-in-der-gemeinde-giesshuebl",
			  "lastmod": "2023-07-04",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/neuausschreibungen-von-finanzierungen-aber-bitte-digitalisiert",
			  "lastmod": "2023-07-06",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/bgm-buchberger-hofamt-priel",
			  "lastmod": "2023-07-04",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/bundesvergaberecht-vs-vergaberechtliche-vorgaben",
			  "lastmod": "2023-07-06",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/frc-kommunale-kreditplattform-1",
			  "lastmod": "2023-07-04",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/frc-am-gemeindetag-2023",
			  "lastmod": "2023-06-19",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/nachhaltigkeit-basis-fuer-darlehenszinsen",
			  "lastmod": "2023-07-03",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/kommunale-finanzen-berichte-1",
			  "lastmod": "2023-05-19",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/frc-am-staedtetag-2023",
			  "lastmod": "2023-05-19",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/webinare-kreditplattform-esg",
			  "lastmod": "2023-07-03",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/esg-umfrage-ergebnis",
			  "lastmod": "2023-05-15",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/ausschreibung-service-1",
			  "lastmod": "2023-08-08",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/frc-podcastfolge-020",
			  "lastmod": "2023-05-16",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/frc-bringt-eigene-kreditplattform",
			  "lastmod": "2023-05-16",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/inflation-schweiz-vs-oesterreich",
			  "lastmod": "2023-03-13",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/ausschreibung-service-2",
			  "lastmod": "2023-03-23",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/frc-bestaetigt-standards",
			  "lastmod": "2023-02-23",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/leitzinsen-februar-2023",
			  "lastmod": "2023-02-02",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/darlehen-ausschreibung-zeitpunkt",
			  "lastmod": "2023-08-08",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/esg-update",
			  "lastmod": "2023-02-02",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/digitale-finanzberatung-fuer-gemeinden",
			  "lastmod": "2023-08-08",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/chatgpt-gemeindefinanzen",
			  "lastmod": "2023-01-09",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/frc-newsletter",
			  "lastmod": "2023-01-02",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/online-ausgabe-public",
			  "lastmod": "2022-12-29",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/frc-weihnachtswunder-2022",
			  "lastmod": "2022-12-21",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/ezb-im-dezember",
			  "lastmod": "2023-02-02",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/mediaplanet-auf-landundgemeinde-info",
			  "lastmod": "2022-12-20",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/datenmanagement-fuer-gemeinden",
			  "lastmod": "2022-12-09",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/wieder-1-milliarde",
			  "lastmod": "2023-02-02",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/nachhaltigkeit-in-der-kommunalfinanzierung",
			  "lastmod": "2022-12-09",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/naechste-zinserhoehung-der-ezb",
			  "lastmod": "2023-02-02",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/zinsanstieg-budgetierung-transparenz",
			  "lastmod": "2023-02-02",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/frc-in-eigener-sache",
			  "lastmod": "2022-10-12",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/frc-stockschuetzen-hofamtpriel",
			  "lastmod": "2022-10-07",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/zinsaenderungsrisiko-frc-modulbaukasten",
			  "lastmod": "2023-02-02",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/neues-frc-zusatzmodul",
			  "lastmod": "2022-09-29",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/nachhaltigkeit-bei-gemeinden",
			  "lastmod": "2022-09-29",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/fed-macht-ernst",
			  "lastmod": "2022-09-23",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/dirndlkirtag-in-rabenstein",
			  "lastmod": "2022-09-22",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/ezb-zieht-durch",
			  "lastmod": "2023-02-02",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/aktuelle-zinsentwicklungen",
			  "lastmod": "2022-11-07",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/ende-der-verwahrgebuehren",
			  "lastmod": "2023-02-02",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/zusatzmodul-marktmonitoring",
			  "lastmod": "2023-02-02",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/zinserhoehung-der-ezb",
			  "lastmod": "2022-07-26",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/frc-fair-ratsam-clever",
			  "lastmod": "2023-03-07",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/gemeinde-bonitaetsranking-2020-frc-module",
			  "lastmod": "2023-02-02",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/frc-auf-der-kommunalmesse",
			  "lastmod": "2023-02-02",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/frc-verstaerkt-die-niederlassung-burgenland",
			  "lastmod": "2022-08-18",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/kommunal-berichtet-zinsaenderungsrisiko",
			  "lastmod": "2023-02-02",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/expertentreff-am-staedtetag-2022",
			  "lastmod": "2022-06-09",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/das-magazin-public-berichtet",
			  "lastmod": "2022-06-14",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/frc-am-staedtetag-in-villach",
			  "lastmod": "2022-05-31",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/laufende-begleitung-des-finanzierungsportfolios",
			  "lastmod": "2022-05-05",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/frc-verstaerkt-die-niederlassung-niederoesterreich",
			  "lastmod": "2022-05-23",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/weltgeschehen-inflationund-zinsen",
			  "lastmod": "2022-09-22",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/public-online",
			  "lastmod": "2022-05-03",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/frc-ausschreibungsservice-mit-effizienten-ergebnissen",
			  "lastmod": "2022-05-03",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/wo-geht-die-zinsreise-hin-aber-was-ist-ueberhaupt-der-leitzins-der-euribor-oder-der-swap-satz",
			  "lastmod": "2022-05-05",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/015-rueckblick-ausblick-weitblick",
			  "lastmod": "2022-05-05",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/verantwortung-und-effizienz-im-finanzierungsmanagement",
			  "lastmod": "2022-05-05",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/der-glasfaser-pionier",
			  "lastmod": "2022-05-05",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/endes-des-chf-libors",
			  "lastmod": "2022-05-05",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/frc-uebernimmt-kreditplattform",
			  "lastmod": "2023-04-18",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/esg-und-nachhaltigkeit-in-der-kommunalfinanzierung-frc-on-air-14",
			  "lastmod": "2022-05-05",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/7747",
			  "lastmod": "2022-05-05",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/von-verwahrentgelten-ueber-strafzinsen-bis-zur-analyse",
			  "lastmod": "2021-11-29",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/frc-finanzierungscontrolling",
			  "lastmod": "2021-11-25",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/70-staedtetag-in-st-poelten-frc-on-air-013",
			  "lastmod": "2022-05-25",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/frc-unterstuetzt-das-festival-cellensis-2",
			  "lastmod": "2021-11-03",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/frc-am-staedtetag-in-st-poelten",
			  "lastmod": "2021-11-29",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/benefizkonzert-bgm-vogl-auf-schloss-thalheim",
			  "lastmod": "2021-10-20",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/platzkonzert-fuer-ein-brandneues-gemeindezentrum-frc-on-air-012",
			  "lastmod": "2021-10-12",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/machen-alternative-financiers-sinn",
			  "lastmod": "2022-01-17",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/frc-legt-sich-standards-auf",
			  "lastmod": "2022-07-14",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/unser-frc-on-air-podcast-von-der-kommunalmesse-011",
			  "lastmod": "2021-10-11",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/frc-erweitert-vertriebsteam-um-manuel-klaus-und-staerkt-back-office",
			  "lastmod": "2021-10-11",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/optimieren-im-sommer",
			  "lastmod": "2021-10-11",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/benefizkonzert-in-kapelln",
			  "lastmod": "2021-10-20",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/frc-auf-der-kommunalmesse-in-tulln",
			  "lastmod": "2021-11-29",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/ende-des-chf-libors-was-ist-zu-tun",
			  "lastmod": "2021-10-11",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/gemeindebundpraesident-alfred-riedl-zu-gast-bei-frc-on-air",
			  "lastmod": "2021-10-11",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/eroeffnung-neuer-kindegarten-durch-lh-mikl-leitner-in-hofamt-priel",
			  "lastmod": "2021-10-11",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/5-jahre-frc-auch-im-kommunalverlag",
			  "lastmod": "2021-10-11",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/webinar-am-22-6-2021-finanzierungsgauschreibungen-leicht-gemacht",
			  "lastmod": "2021-11-29",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/kirchdorf-krems-009-ladies-first",
			  "lastmod": "2021-06-01",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/public-berichtet-im-mai",
			  "lastmod": "2021-11-29",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/5-jahre-frc-jubilaeumsfolge-8",
			  "lastmod": "2021-05-14",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/kommunale-finanzen-lohnt-sich-die-vermeidung-von-verwahrgebuehren",
			  "lastmod": "2021-10-11",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/horen-sie-was-es-in-altenmarkt-an-der-triesting-neues-gibt",
			  "lastmod": "2021-04-27",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/kreditausschreibung-fuer-die-gemeinde-wieselburg-land",
			  "lastmod": "2021-10-11",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/investitionen-von-gemeinde-sichern-arbeitsplatze",
			  "lastmod": "2021-10-11",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/digitales-wissensmanagement-public-online",
			  "lastmod": "2021-11-29",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/podcast-folge-6-leasing",
			  "lastmod": "2021-03-12",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/finanzierungscontrolling-plus-digitale-kreditplattform-komuno-at",
			  "lastmod": "2021-07-16",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/corona-bringt-auch-chancen-fuer-die-gemeindefinanzen",
			  "lastmod": "2021-11-29",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/frc-in-der-kommunalen-fachpresse",
			  "lastmod": "2021-11-29",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/frc-weitet-produktpalette-um-versicherungsloesungen-aus",
			  "lastmod": "2022-11-03",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/podcast-frc-on-air-4-persoenlicher-kundenkontakt-ist-trumpf",
			  "lastmod": "2021-04-27",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/attraktive-zinssaetze-fuer-ihre-gemeinde-trotz-oder-gerade-wegen-corona",
			  "lastmod": "2021-11-29",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/frc-on-air-der-podcast-zu-gemeindefinanzen",
			  "lastmod": "2021-10-11",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/erfolgreiche-klaerung-der-zinsindikatoren-fuer-die-gemeinde-poetting-ooe",
			  "lastmod": "2020-12-17",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/optimierungen-im-kommunalen-kreditportfolio-der-stadt-melk",
			  "lastmod": "2020-11-17",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/kommunales-kreditportfolio-der-stadt-korneuburg",
			  "lastmod": "2021-11-29",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/attraktive-zinssaetze-fuer-ihr-kommunales-finanzierungsportfolio",
			  "lastmod": "2021-07-05",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/digitalisierung-der-kommunalfinanzierung",
			  "lastmod": "2021-11-29",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/frc-eroeffnet-niederlassung-in-st-poelten",
			  "lastmod": "2021-11-29",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/personalisierte-digitalisierung-des-kommunalen-kreditportfolios",
			  "lastmod": "2021-07-05",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/das-kommunal-berichtet-zum-thema-finanzierung",
			  "lastmod": "2021-11-29",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/crm-kundensupport-it",
			  "lastmod": "2021-10-11",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/portfoliogedanke-bei-kommunalen-finanzinstrumenten-veranlagung-finanzierung",
			  "lastmod": "2022-02-22",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/einlagensicherung-bei-gemeinden",
			  "lastmod": "2020-07-21",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/mediaplanet-bringt-land-und-gemeinde",
			  "lastmod": "2021-10-25",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/digitales-finanzierungscontrolling-und-laufendes-reporting-fuer-kommunen",
			  "lastmod": "2020-06-26",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/ogh-zu-negativzinsen-stadt-steyr-bei-vertraegen-ohne-zinsuntergrenze-und-was-wir-aus-der-meinung-namhafter-juristen-lernen",
			  "lastmod": "2020-06-19",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/public-finance-wir-stellen-ein-und-suchen-dich-fuer-unseren-digitalen-service",
			  "lastmod": "2021-11-29",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/corona-hilfspaket-2020-fuer-gemeinden-und-ueberlegungen-in-bezug-auf-finanzierungaspekte",
			  "lastmod": "2020-06-04",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/verwahrgebuehren-bei-spareinlagen-von-gemeinden",
			  "lastmod": "2021-10-11",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/fairness-zwischen-gemeinde-und-bankauch-in-der-krise",
			  "lastmod": "2020-06-14",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/kreditausschreibungen-fuer-staedte-gemeinden-beduerfen-experten-und-personalisierter-digitalisierung",
			  "lastmod": "2021-07-05",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/referenz-der-gemeinden-zur-kreditaufnahme-in-der-krise",
			  "lastmod": "2020-05-12",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/liquiditaetssicherung-und-kreditausschreibungen",
			  "lastmod": "2021-11-29",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/negative-zinsindikatoren-und-unsere-erfahrungen-bei-kreditvertraegen-fuer-gemeinden",
			  "lastmod": "2021-11-29",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/kommunal-update-negative-zinsindikatoren",
			  "lastmod": "2021-11-29",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/gemeinden-brauchen-auch-im-finanzbereich-eine-externe-laufende-begleitung-mag-gerold-stagl-buergermeister-der-freistadt-rust-burgenland",
			  "lastmod": "2020-06-08",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/negativzinsen-bei-gemeinden",
			  "lastmod": "2021-11-29",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/das-sagen-unsere-kunden-wir-danken-fuer-das-vertrauen",
			  "lastmod": "2021-03-18",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/attraktive-bedingungen-fuer-kommunalfinanzierungen",
			  "lastmod": "2021-11-29",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/frc-unterstuetzt-das-festival-cellensis",
			  "lastmod": "2019-11-18",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/haben-sie-schon-ihre-erstanalyse",
			  "lastmod": "2020-04-24",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/aktuelle-situation-zum-thema-negativzinsen-bei-krediten",
			  "lastmod": "2020-01-24",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/frc-am-am-69-oesterreichischen-staedtetag-2019",
			  "lastmod": "2019-05-15",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/kreditausschreibung-erobert-die-kreditplattform-die-kommunalfinanzierung",
			  "lastmod": "2022-01-03",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/case-study-leistungen-kommunen",
			  "lastmod": "2021-07-22",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/update-negativzinsen-fuer-gemeinden-und-unternehmen",
			  "lastmod": "2018-03-05",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/zufriedene-kunden",
			  "lastmod": "2018-01-31",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/aktuelle-judikatur-zur-weitergabe-von-negativen-kreditzinsen-an-kreditnehmer",
			  "lastmod": "2017-09-27",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/wie-sichere-ich-meine-fx-risiken-ab",
			  "lastmod": "2017-06-21",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/der-querdenker-gemeindefinanzbericht-2015",
			  "lastmod": "2017-09-26",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/der-querdenker-vrv-2015-bewertung-von-gemeindevermoegen",
			  "lastmod": "2016-11-02",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/der-querdenker-zinsanstieg-ante-portas",
			  "lastmod": "2016-10-31",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/gemeinden-in-der-zinsfalle",
			  "lastmod": "2016-10-31",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/unser-ansatz-im-bereich-veranlagung",
			  "lastmod": "2016-10-31",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/modernes-risikomanagement-wie-sichere-ich-fx-zinsrisiken-ab",
			  "lastmod": "2016-10-31",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/regularien-fuer-banken-und-versicherungen",
			  "lastmod": "2016-05-25",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/fairness-zwischen-unternehmer-kommune",
			  "lastmod": "2016-04-28",
			  "changefreq": "weekly",
			  "priority": 0.5
			},
			{
			  "loc": "http://frc.localhost/blog/negative-zinsen-und-kredite",
			  "lastmod": "2016-05-20",
			  "changefreq": "weekly",
			  "priority": 0.5
			}
		  ]
		}
	  };
	  console.log(sitemap.urlset.url.length);

	  let errorSites = [];
	  sitemap.urlset.url.forEach(async (site) => {
		  const response = await fetch(site.loc);
		  if (!response.ok) {
			  errorSites.push(site.loc);
		  }
		  console.log(site.loc);
	  });
}

// Run the init function as soon as the DOM tree has been loaded
if (document.readyState !== 'loading') siteInitialization();
else document.addEventListener('DOMContentLoaded', siteInitialization);